import React from 'react';

const LiveCasino = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "16",
    height: "17",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.99967 14.988C11.6816 14.988 14.6663 12.0032 14.6663 8.32135C14.6663 4.63945 11.6816 1.65468 7.99967 1.65468C4.31778 1.65468 1.33301 4.63945 1.33301 8.32135C1.33301 12.0032 4.31778 14.988 7.99967 14.988Z",
      stroke: "#E2E4EE"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.9997 8.32135L6.33301 5.65468V10.988L10.9997 8.32135Z",
      fill: "#E2E4EE"
    }
  )
);
LiveCasino.displayName = "Icons.LiveCasino";

export { LiveCasino };
//# sourceMappingURL=LiveCasino.js.map
